import React, { useEffect } from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  className = "",
  scrollable = false,
}) => {
  // Handle body scroll lock when modal is open
  useEffect(() => {
    if (isOpen) {
      // Prevent body scroll
      document.body.style.overflow = "hidden";
    } else {
      // Restore body scroll
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Handle escape key to close modal
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  // Handle click outside modal to close
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Prevent modal content clicks from bubbling up to backdrop
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      aria-hidden={!isOpen}
      onClick={handleBackdropClick}
    >
      <div className="modal-dialog" role="document" onClick={handleModalClick}>
        <div
          className={`modal-content ${className}`}
          style={{
            maxHeight: "95vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="modal-header">
            <div className="inner-head">
              {title && <div className="modal-title">{title}</div>}
              {
                <button
                  type="button"
                  className="close"
                  onClick={onClose}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              }
            </div>
          </div>
          <div
            className={`modal-body ${scrollable ? "scrollable scrollable-y" : ""}`}
            style={scrollable ? { overflowY: "auto", flex: 1 } : {}}
          >
            {children}
          </div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/Modal.js